import React from "react";
import { TextField } from "@mui/material";

const DSTextField = (props: React.ComponentProps<typeof TextField>) => {
  return <TextField {...props} variant="outlined" />;
};

export default DSTextField;
